import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body p-0 d-flex justify-content-between flex-column overflow-hidden" }
const _hoisted_2 = { class: "d-flex flex-stack flex-grow-1 px-9 pt-9 pb-3" }
const _hoisted_3 = { class: "symbol symbol-45px" }
const _hoisted_4 = { class: "symbol-label" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column text-end" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder text-gray-800 fs-3" }, "Sales"),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400 fw-bold" }, "Oct 8 - Oct 26 21")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_apexchart = _resolveComponent("apexchart")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", {
              class: [`svg-icon-${_ctx.chartColor}`, "svg-icon svg-icon-2x"]
            }, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-line1.svg" })
            ], 2)
          ])
        ]),
        _hoisted_5
      ]),
      _createVNode(_component_apexchart, {
        class: "mixed-widget-10-chart",
        options: _ctx.chartOptions,
        series: _ctx.series,
        type: "bar",
        height: _ctx.chartHeight
      }, null, 8, ["options", "series", "height"])
    ])
  ], 2))
}